// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--hlP6D","content":"dece2e673c--content--U9uFp","reaction":"dece2e673c--reaction--hRjR0","comment":"dece2e673c--comment--BXDhL"};